module.exports = __webpack_public_path__ + "img/vmk.39e5000d.png";